<template>
  <div>
    <h4 v-if="mainStore.bookingSystem.equipes.has_equipes" class="font-weight-bold my-3"><v-icon
        icon="mdi-account-group" color="primary" size="xs-small"></v-icon> Gestion d'équipes</h4>
    <div class="rounded bg-grey_3 pa-3 my-3 bordered" v-for="(equipe, index) in mainStore.bookingSystem.equipes.list"
      :key="index">
      <div class="d-flex flex-row flex-wrap justify-space-between items-center mb-2 gap">
        <div class="text-h5 font-weight-bold">{{ equipe.get_entete(index) }}</div>
        <v-btn v-if="!buyDossardBourseView" variant="elevated" elevation="0" size="small" color="red-darken-4"
          @click="show_delete_equipe(index)">
          <v-icon icon="mdi-delete"></v-icon>
        </v-btn>
      </div>

      <v-text-field v-model="equipe.nom"
        @change="change_nom_equipe(equipe, $formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list))"
        label="Nom de l'équipe" hint="Accepté : Majuscules, chiffres, espaces et certains caractères spéciaux"
        :rules="[$formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list)]"></v-text-field>
      <div v-if="equipe.extra_fields.length > 0">
        <v-row>
          <v-col cols="12" md="6" v-for="(field, index) in equipe.extra_fields" :key="index">
            <v-text-field @change="change_extra_fields(equipe, field)" v-model="field.value" :label="field.label"
              :required="field.required"></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div>
        Nombre de coureurs requis: <b>{{ equipe.coureurs.length }}/{{ equipe.size }}</b>
      </div>
      <div v-if="equipe.coureurs.length < equipe.size">
        <v-alert color="dark-red" variant="tonal" class="mb-2" type="error">
          L'équipe n'est pas complète, il manque encore {{ equipe.size - equipe.coureurs.length }} coureur(s). En
          ajoutant un nouveau participant sur ce parcours, il sera automatiquement ajouté à cette équipe.
        </v-alert>
      </div>
      <div>
        Parcours: <b>{{ equipe.nom_course }}</b>
      </div>
      <div>Coureurs dans l'équipe:</div>
      <div class="mt-2 d-flex flex-wrap">
        <v-chip class="mx-2" color="primary-dark font-weight-bold" v-for="coureur in equipe.coureurs"
          :key="coureur.index">{{ get_coureur_name(coureur) }}</v-chip>
      </div>
    </div>
    <v-dialog v-model="show_confirm_delete_equipe" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-body-1">Voulez-vous vraiment <b>supprimer</b> cette équipe ?</div>
          <div>L'équipe ainsi que tous les coureurs associés seront supprimés.</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red-darken-4" @click="show_confirm_delete_equipe = false">Non</v-btn>
          <v-btn color="green-darken-4" @click="delete_equipe_confirm">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from "@/stores/bookingStore";


export default {
  data() {
    return {
      index_equipe_to_delete: null,
      show_confirm_delete_equipe: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    buyDossardBourseView() {
      return this.$route.name == "BuyDossardBourse";
    },
  },
  watch: {
    'bookingStore.inscriptions': {
      deep: true,
      handler() {
        const add_missing_inscriptions = false;
        this.mainStore.bookingSystem.equipes.assign_teams(add_missing_inscriptions);
      },
    },
  },

  methods: {
    show_delete_equipe(index) {
      this.show_confirm_delete_equipe = true;
      this.index_equipe_to_delete = index;
    },
    delete_equipe_confirm() {
      this.show_confirm_delete_equipe = false;
      this.bookingStore.deleteInscriptionsFromEquipe(this.mainStore.bookingSystem.equipes.list[this.index_equipe_to_delete]);
      this.bookingStore.compute_cart();
      this.mainStore.bookingSystem.preselection = null;
      this.index_equipe_to_delete = null;
    },

    change_nom_equipe(equipe, verification) {
      if (verification != true) {
        return;
      }
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        let inscription = this.bookingStore.inscriptions[i];
        for (let j = 0; j < equipe.coureurs.length; j++) {
          if (equipe.coureurs[j].index == i) {
            inscription.set_equipe_name(equipe.nom);
          }
        }
      }
    },

    change_extra_fields(equipe, field) {
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        let inscription = this.bookingStore.inscriptions[i];
        for (let j = 0; j < equipe.coureurs.length; j++) {
          if (equipe.coureurs[j].index == i) {
            inscription.set_extra_equipe_fields(field);
          }
        }
      }
    },


    get_coureur_name(coureur) {
      if (coureur.name != "" && coureur.name != " ") {
        return coureur.name;
      } else {
        return "Coureur  n°" + (coureur.index + 1);
      }
    },

  },
};
</script>

<style lang="scss" scoped></style>